import r from"./_baseHas.js";import a from"./_hasPath.js";var t=r,o=a;var s=function(r,a){return null!=r&&o(r,a,t)};export{s as default};
//# sourceMappingURL=has.js.map
